module.exports = __webpack_public_path__ + "img/home_log.7df654b1.svg";